import styles from "./QuestionFallback.module.scss";

import { ChangeEvent, useCallback } from "react";

import { SurveyQuestionComponentProps } from "@/modules/session-survey/types/SurveyQuestionComponentProps";
import { AppInput } from "@/modules/shared/components/AppInput";

export const QuestionFallback = ({
  question,
  value,
  onAnswer,
}: SurveyQuestionComponentProps) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onAnswer(event.target.value);
    },
    [onAnswer],
  );

  return (
    <section className={styles.container}>
      <h2 className={styles.prompt}>{question.prompt}</h2>
      <AppInput
        value={value?.toString() ?? ""}
        onChange={handleChange}
        type="text"
        ariaLabel={question.prompt}
        className={styles.input}
      />
    </section>
  );
};
